<aside class="main-sidebar sidebar-dark-primary elevation-4">
    <div class="sidebar">
        <div class="leftpanel_conteiner-logo">
            <img
                src="assets/images/logo-SiriiagroV1-blanco.svg"
                alt="Logo Siriiagro" />
        </div>
        <nav class="mt-2" *ngIf="tienePermisos || esUsuarioInstitucional">
            <ul
                class="nav nav-pills nav-sidebar flex-column"
                data-widget="treeview"
                data-accordion="false">
                <ng-container
                    *ngIf="empresasAsociadas || esUsuarioInstitucional; else noEmpresas">
                    <li
                        [hidden]="!tieneAccesoItem(item)"
                        *ngFor="let item of menuItems"
                        class="nav-item"
                        [ngClass]="{ leftpanel_active: item.active }">
                        <ng-container *ngIf="!item.header; else header">
                            <a [routerLink]="item.route" class="nav-link">
                                <i *ngIf="item.icon">
                                    <img
                                        *ngIf="item.icon && !item.iconClass"
                                        [src]="'assets/images/' + item.icon"
                                        class="sidebar-icon"
                                        alt="Icono de menú" />
                                </i>
                                <i
                                    *ngIf="item.iconClass"
                                    class="sidebar-icon"
                                    [ngClass]="item.iconClass"></i>
                                <p
                                    [style.padding-left]="
                                        item.paddingLeft || null
                                    ">
                                    {{ item.label }}
                                </p>
                            </a>
                        </ng-container>

                        <ng-template #header>
                            <a class="nav-header">{{ item.label }}</a>
                        </ng-template>
                    </li>
                </ng-container>

                <ng-template #noEmpresas>
                    <div class="p-3 text-white-50 text-center">
                        <p class="small mb-2">Asociar una empresa</p>
                    </div>
                    <li class="nav-item">
                        <a
                            routerLink="/nueva-empresa"
                            class="nav-link leftpanel_active">
                            <i class="nav-icon fas fa-building"></i>
                            <p>Asociar Empresa</p>
                        </a>
                    </li>
                </ng-template>
            </ul>
        </nav>
    </div>
</aside>
